import {HttpRequest} from '../Data/HttpRequest'
import {server} from '../Data/BuildEnvironment'

export function download(id: number): HttpRequest {
    return {
        verb: 'GET',
        url: `${server}/inquiry-position-attachments/${id}/file`,
        headers: {},
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Request/InquiryPositionAttachmentResource.ts